var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddfriend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#504538",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 186 c-10 -26 4 -48 28 -44 17 2 23 10 23 28 0 18 -6 26 -23 28 -13 2 -25 -3 -28 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 186 c-10 -26 4 -48 28 -44 17 2 23 10 23 28 0 18 -6 26 -23 28 -13 2 -25 -3 -28 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 109 c-10 -5 -18 -19 -18 -29 0 -16 7 -20 39 -20 35 0 39 3 43 30 4 27 2 30 -21 30 -14 0 -34 -5 -43 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 109 c-10 -5 -18 -19 -18 -29 0 -29 56 -28 63 0 3 13 14 20 29 20 18 0 20 2 8 10 -19 13 -60 12 -82 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 65 c0 -8 -7 -15 -15 -15 -8 0 -15 -4 -15 -10 0 -5 7 -10 15 -10 8 0 15 -7 15 -15 0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 7 15 15 15 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 7 -15 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddfriend);
export default __webpack_public_path__ + "static/media/addfriend.6e1199b021d64228ca044d5a45bbc5eb.svg";
export { ForwardRef as ReactComponent };